import { AssetProviderUid } from '@gelato-api-ui/core/designs/asset-provider-uid.enum';

export const freeAssetProviderUidsWithActiveSubscription = [
  AssetProviderUid.SHUTTERSTOCK_ESSENTIALS,
  AssetProviderUid.CLIPART,
];
